import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=e60bbd8e"
import script from "./TaskRow.vue?vue&type=script&lang=ts"
export * from "./TaskRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports